import { GetClientOrdersRequest } from '@/api/market-shop/orders/get-client-orders'
import { MarketShopOrderStatus } from '@/models'

export const SUPPORTED_STATUSES: Array<MarketShopOrderStatus> = [
  'new',
  'in_progress',
  'awaiting_pickup',
]

export const marketShopOrdersInitialFilters: GetClientOrdersRequest = {
  limit: 10,
  status: SUPPORTED_STATUSES,
}
